<div class="cc-page">
  <div class="cc-layout">
    <section class="cc-panel">
      <div class="panel-header">
      </div>

      <div class="control-row">
        <div class="status-toolbar">
          <div class="filter-buttons">
            <button
              *ngFor="let filter of statusFilters"
              type="button"
              class="filter-button"
              [class.active]="selectedStatusFilter === filter.value"
              (click)="setStatusFilter(filter.value)">
              <span class="label">{{ filter.label }}</span>
              <span class="count">{{ getStatusCount(filter.value) }}</span>
            </button>
          </div>
          <div class="filter-search">
            <input type="text"
                   placeholder="Search by change ID or description"
                   autocomplete="off"
                   spellcheck="false"
                   [value]="searchTerm"
                   (focus)="onSearchFocus()"
                   (blur)="onSearchBlur()"
                   (input)="onSearchTermChange($any($event.target).value)" />
            <div class="search-suggestions" *ngIf="showSearchSuggestions">
              <button type="button"
                      class="suggestion-item"
                      *ngFor="let suggestion of searchSuggestions"
                      (mousedown)="onSuggestionPointerDown($event, suggestion.change)">
                <span class="suggestion-primary">{{ suggestion.primary }}</span>
                <span class="suggestion-secondary" *ngIf="suggestion.secondary">{{ suggestion.secondary }}</span>
              </button>
            </div>
          </div>
        </div>

        <div class="active-select-card" *ngIf="filteredChanges.length; else noFilteredChanges">
          <div class="change-row-list" role="list">
            <div
              class="change-row"
              role="listitem"
              tabindex="0"
              *ngFor="let change of filteredChanges; trackBy: trackByCr"
              [class.active]="selectedChange?.crNumber === change.crNumber">
              <div
              (click)="selectChange(change)"
              (keydown.enter)="selectChange(change)">
                <div class="row-primary" *ngIf="!isRowExpanded(change)">
                  <button
                    type="button"
                    class="row-toggle-btn"
                    (click)="toggleRow(change, $event)"
                    (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                    [attr.aria-label]="'Expand ' + change.crNumber">
                    <mat-icon>chevron_right</mat-icon>
                  </button>
                  <span class="row-id">{{ change.crNumber }}</span>
                  <ng-container *ngIf="getStatusBadge(change) as badge">
                    <span class="status-badge badge-compact" [ngClass]="badge.className">{{ badge.label }}</span>
                  </ng-container>
                </div>
                <div class="row-secondary cc-last-edited" *ngIf="!isRowExpanded(change)">
                  <span>Last edited:</span>
                  <ng-container *ngIf="getLastEditedDate(change) as led; else noLastEditedCollapsed">
                    <span class="cc-datetime">{{ led | date:'short' }}</span>
                  </ng-container>
                  <ng-template #noLastEditedCollapsed>
                    <span class="cc-datetime cc-datetime--empty">—</span>
                  </ng-template>
                </div>
              </div>
              <!-- Info -->
              <div *ngIf="isRowExpanded(change)">
                <header class="detail-header">
                  <div class="title-group">
                    <button
                      type="button"
                      class="row-toggle-btn"
                      (click)="toggleRow(change, $event)"
                      (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                      [attr.aria-label]="'Collapse ' + change.crNumber">
                      <mat-icon>expand_more</mat-icon>
                    </button>
                    <label class="change-title-label">Change ID:</label>
                    <div class="change-title-input-wrap">
                      <input
                        class="change-title-input"
                        [class.error]="!!crNumberValidationError"
                        type="text"
                        [value]="selectedChange.crNumber"
                        (focusout)="onCrNumberBlur($any($event.target).value)"
                        (keydown.enter)="onCrNumberBlur($any($event.target).value)"
                        (keydown.tab)="onCrNumberBlur($any($event.target).value)" />
                      <div class="field-error" *ngIf="crNumberValidationError">{{ crNumberValidationError }}</div>
                    </div>
                    <ng-container *ngIf="getStatusBadge(selectedChange) as badge">
                      <span class="status-badge badge-compact header-status-badge" [ngClass]="badge.className">{{ badge.label }}</span>
                    </ng-container>
                  </div>
                  <div class="actions">
                    <!-- Download CSV after Submit button -->
                    <button
                      *ngIf="normalizeStatus(selectedChange) === 'submitted'; else editButtonTpl"
                      mat-stroked-button
                      color="primary"
                      class="btn-outline"
                      (click)="downloadChangeCsv(selectedChange)">
                      <mat-icon>download</mat-icon><span>Download CSV</span>
                    </button>
                    <!-- Edit button -->
                    <ng-template #editButtonTpl>
                      <button
                        mat-stroked-button
                        color="primary"
                        class="btn-outline"
                        (click)="editChange()"
                        [disabled]="!isChangeEditable(selectedChange)">
                        <mat-icon>tune</mat-icon><span>Edit</span>
                      </button>
                    </ng-template>
                    <!-- Submit Button -->
                    <button mat-raised-button color="primary" class="btn-primary" 
                      (click)="submitChange()"
                      [disabled]="isSubmitting || !isChangeEditable(selectedChange)"
                      *ngIf="normalizeStatus(selectedChange) == 'active'">
                      <ng-container *ngIf="!isSubmitting; else submittingTpl">Submit</ng-container>
                    </button>
                    <ng-template #submittingTpl>
                      <div class="btn-loading">
                        <mat-progress-spinner diameter="22" mode="indeterminate"></mat-progress-spinner>
                        <span>Submitting...</span>
                      </div>
                    </ng-template>
                    <!-- Cancel Button -->
                    <button mat-raised-button color="primary" class="btn-primary"
                      (click)="cancelChange()"
                      [disabled]="isCanceling"
                      *ngIf="normalizeStatus(selectedChange) == 'active' || normalizeStatus(selectedChange) == 'submitted'">
                      <ng-container *ngIf="!isCanceling; else cancelingTpl">Cancel</ng-container>
                    </button>
                    <ng-template #cancelingTpl>
                      <div class="btn-loading">
                        <mat-progress-spinner diameter="22" mode="indeterminate"></mat-progress-spinner>
                        <span>Canceling...</span>
                      </div>
                    </ng-template>
                    <!-- Set Active Button -->
                    <button mat-raised-button color="primary" class="btn-primary"
                      (click)="setActive()"
                      [disabled]="isSubmitting"
                      *ngIf="normalizeStatus(selectedChange) == 'submitted' || normalizeStatus(selectedChange) == 'cancelled'">
                      <ng-container *ngIf="!isSubmitting; else submittingTpl">Set Active</ng-container>
                    </button>
                    <!-- Close Button -->
                    <button mat-raised-button color="primary" class="btn-primary" 
                      (click)="closeChange()"
                      [disabled]="isClosing"
                      *ngIf="normalizeStatus(selectedChange) == 'submitted'">
                      <ng-container *ngIf="!isClosing; else closingTpl">Close</ng-container>
                    </button>
                    <ng-template #closingTpl>
                      <div class="btn-loading">
                        <mat-progress-spinner diameter="22" mode="indeterminate"></mat-progress-spinner>
                        <span>Closing...</span>
                      </div>
                    </ng-template>
                  </div>
                </header>

                <div class="meta-grid">
                  <div class="meta-block">
                    <div class="meta-label" style="display: flex; align-items: center; gap: 8px;">
                      <span>Created By:</span>
                      <a *ngIf="selectedChange.createdBy.gmid; else noLink" 
                         [href]="'https://peoplefinder.gm.com/Person/Show/' + selectedChange.createdBy.gmid" 
                         target="_blank"
                         rel="noopener noreferrer">{{ selectedChange.createdBy?.displayName || '—' }}</a>
                      <ng-template #noLink>
                        <span>{{ selectedChange.createdBy?.displayName || '—' }}</span>
                      </ng-template>
                    </div>

                    <div class="cc-last-edited">
                      <span class="meta-label">Last edited:</span>
                      <ng-container *ngIf="getLastEditedDate(selectedChange) as led; else noLastEditedExpanded">
                        <span class="cc-datetime">{{ led | date:'short' }}</span>
                      </ng-container>
                      <ng-template #noLastEditedExpanded>
                        <span class="cc-datetime cc-datetime--empty">—</span>
                      </ng-template>
                    </div>
                  </div>
                </div>

                <div class="section description-section">
                  <ng-container>
                    <label class="description-label">Description:</label>
                    <textarea
                      class="description-input"
                      rows="2"
                      [class.collapsed]="!descriptionExpanded"
                      [value]="selectedChange.itemDescription || ''"
                      placeholder="Enter description"
                      (focus)="descriptionExpanded = true"
                      (focusout)="descriptionExpanded = false; onDescriptionBlur($any($event.target).value)"
                      (keydown.tab)="onDescriptionBlur($any($event.target).value)"></textarea>
                    <button
                      *ngIf="(selectedChange.itemDescription || '').length > 120"
                      type="button"
                      class="toggle-link"
                      (click)="descriptionExpanded = !descriptionExpanded">
                      {{ descriptionExpanded ? 'Show less' : 'Show more' }}
                    </button>
                  </ng-container>
                </div>

                <div class="section">
                  <div class="cli-card" *ngIf="selectedChange.cliConfig?.length; else noCli">
                    <ng-container *ngIf="getFlattenedCliItems(selectedChange) as cliItems">
                      <div class="cli-card-header cli-card-title" *ngIf="selectedChange.cliConfig?.length">Configuration Items</div>
                      <ng-container *ngIf="selectedChange.cliConfig?.length; else noCli">
                        <div class="group-changes-section" *ngFor="let groupChanges of selectedChange.cliConfig; let si = index">
                          <h4 *ngIf="groupChanges.groupName && groupChanges.changes.length > 0" class="clickable-group-header">
                            {{ groupChanges.groupName }}
                          </h4>
                          <ul class="changes-summary-list">
                            <li *ngFor="let change of groupChanges.changes">
                              <div class="change-item-wrapper change-content">
                                <div class="">
                                  <div class="change-line">{{ change.summary }}</div>
                                  <div class="change-meta" *ngIf="change.meta">{{ change.meta }}</div>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                  <ng-template #noCli>
                    <div class="empty-inline">No Configuration Items</div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ng-template #noFilteredChanges>
        <div class="no-results-card">
          <div class="no-results-title">No changes match your filters.</div>
          <div class="no-results-meta">Try selecting a different status or clearing the search.</div>
        </div>
      </ng-template>
    </section>
  </div>
</div>